module.exports = "/fonts/FiraSans-ExtraLightItalic.ttf";